@if (canLoadMore()) {
    <div class="flex flex-row w-full justify-center">
        <button class="text-primary hover:text-primary-hover font-medium" (click)="loadMore.emit()">
            {{ label() | translate }}
        </button>
    </div>
}
